module.exports = __webpack_public_path__ + "static/media/generate_icon_grey.36d4fc77.svg";